import { render, staticRenderFns } from "./TemplateActions.vue?vue&type=template&id=01c1113a&scoped=true&"
import script from "./TemplateActions.vue?vue&type=script&lang=ts&"
export * from "./TemplateActions.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateActions.vue?vue&type=style&index=0&id=01c1113a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c1113a",
  null
  
)

export default component.exports